export const calculateAvgPrice = (priceHistory, count) => {
  if (!priceHistory || priceHistory.length === 0) return 0;
  
  const prices = priceHistory.map(point => point.price);
  const size = prices.length;
  
  // Return avg if there are not enough elements
  if (size < count) {
    return prices.reduce((sum, price) => sum + price, 0) / size;
  }
  
  // Sum last 'count' values
  const sum = prices.slice(-count).reduce((acc, price) => acc + price, 0);
  return sum / count;
};

export const calculateAvgChangePercent = (priceHistory, totalPriceCount, recentPriceCount) => {
  const avgPrice = calculateAvgPrice(priceHistory, totalPriceCount);
  const recentAvgPrice = calculateAvgPrice(priceHistory, recentPriceCount);
  
  if (avgPrice === 0) return 0;
  return ((recentAvgPrice - avgPrice) / avgPrice) * 100;
}; 